export const SOCKET_MESSAGE_TYPE = {
  authRequired: 'AUTHREQ',
  authChallenge: 'AUTHCHALLENGE',
  authResponse: 'AUTHRESPONSE',
  subscriptionRequest: 'SUBREQ',
  subscriptionResponse: 'SUBRESPONSE',
  messageUpdate: 'MESSAGEUPDATE',
  flowUpdate: 'FLOWUPDATE'
};
